var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.formData,
      "label-width": "150px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "表单ID："
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.formId) + " ")]), _c("el-form-item", {
    attrs: {
      label: "表单名称："
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.title) + " ")]), _c("el-form-item", {
    attrs: {
      label: "充值配置信息:"
    }
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.formData.formApi,
      height: "350px",
      "header-row-style": _vm.headStyle,
      "row-style": _vm.rowStyle
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "api名称",
      prop: "name"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "请求method",
      prop: "method"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "是否需要记录日志"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.isLog === 0 ? "否" : "是") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "是否远程调用(需要后台转发请求)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.isRemoteCall === 0 ? "否" : "是") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "api的url",
      prop: "url"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };